import { z } from 'zod';

export const maxDiscountSchema = z.object({ maxDiscountPercent: z.coerce.number().positive({ message: 'Max chegirma foizini kiriting!' }) });

export type MaxDiscount = z.infer<typeof maxDiscountSchema>;
